import React from "react";
import { Textarea as BaseTextarea } from "../../../ui/textarea";
import { withFormField } from "./withFormField";
import { TextareaProps } from "../types";
import { cn } from "../../../utils";

const TextareaWithField = withFormField<TextareaProps>(BaseTextarea);

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ variant = "default", className, ...props }, ref) => {
    return (
      <TextareaWithField
        {...props}
        ref={ref}
        className={cn(
          {
            "font-mono text-sm leading-[1.4] rounded dark:bg-fill-input-neutral-idle px-3 py-2 [[readonly]]:text-text-input-neutral-placeholder [[readonly]]:border [[readonly]]:border-border-input-neutral-idle [[readonly]]:bg-fill-input-neutral-idle":
              variant === "code",
          },
          className,
        )}
      />
    );
  },
);
